module.exports = __webpack_public_path__ + "static/media/cicek2.410cbda2.jpg";